// import 'es6-promise/auto'
// import 'es6-promise/auto'
import {createStore} from 'vuex'
import * as actions from "./actions";
import * as mutations from "./mutations";
import getters from "./getters";

const store = createStore({
    // plugins: [createLogger()],
    strict: true,
    state: {
        //User data
        mirror: window.init.mirror,
        app: window.init.app,
        user: window.init.user,
        isActive: window.init.isActive,
        isCardActive: window.init.isCardActive,
        isMobileBlock: window.init.isMobileBlock,
        isMobileDevice: window.init.isMobileDevice,
        isLoadingAuth: true,
        isLoadingLatestEps: true,
        showMenu: false,

        //General
        backLink: "/",
        isModalActive: false,

        homeSlide: null,
        mediaSlide: null,
        movieSlide: null,
        videoSlide: null,
        pageSlide: null,

        //Medias
        latestMedias: [],
        latestMovies: [],
        popularMedias: [],
        upComingMedias: [],
        homeCatMedias: [],
        mediaList: [],
        likedMediaList: [],
        media: null,
        actors: [],
        relatedMedias: [],
        seasonMedias: [],
        cats: [],
        seasons: [],
        suggestedMedias: [],

        //Episode
        latestEpisodes: [],
        historyEpisodes: [],

        //Episode watch
        isLoadingEpisode: false,
        episode: null,
        episodes: [],
        allEpisodes: [],
        episodeGroupList: [],
        canWatch: false,
        isFree: false,
        warnMsg: "",
        comments: [],
        commentCount: 0,

        //Content
        contentData: null,

        //Payment
        paymentData: null,
        paymentOptions: [],

        //Movies
        movieCats: [],
        movies: [],
        movie: null
    },

    getters: getters,
    mutations,
    actions,
})

export default store;